import { render, staticRenderFns } from "./TimeCaseModify.vue?vue&type=template&id=54607a8d&scoped=true&"
import script from "./TimeCaseModify.vue?vue&type=script&lang=js&"
export * from "./TimeCaseModify.vue?vue&type=script&lang=js&"
import style0 from "./TimeCaseModify.vue?vue&type=style&index=0&id=54607a8d&lang=less&scoped=true&"
import style1 from "./TimeCaseModify.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54607a8d",
  null
  
)

export default component.exports